import HandleAvatar from './HandleAvatar';

/**
 * The post header's name, as a handle rather than a person.
 *
 * SINCE TASK 5.6 NO `User` REACHES THIS AT ALL. Flarum's `Avatar` derives its
 * image, `alt`, `title`, `aria-label`, fallback initial and background colour
 * from the User it is handed; 5.4 could override two of those from outside and
 * no more, which left the picture itself being that person's real, stable
 * upload -- the same image in every Issue, beside a pseudonym. `HandleAvatar`
 * is drawn from the handle string instead, so there is nothing left to leak.
 *
 * Badges are still left alone. A group badge on a pseudonymous post is a real
 * leak, but whether handles carry role tags at all is a spec question -- the
 * definitions document allows characteristics "so long as those characteristics
 * do not threaten identity leakage" -- and not a rendering one. Recorded for
 * the sweep.
 *
 * Moved out of `index.tsx` at Task 4.2, unchanged, so the reply preview can draw
 * exactly the heading your real post will have.
 */
export default function nameHeading(handle, self) {
  return m("h3", {
    className: "PostUser-name"
  }, HandleAvatar(handle, {
    className: 'Post-avatar',
    self
  }), m("span", {
    className: "IdeaSynqHandle"
  }, handle));
}